var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-memory-card-container",style:({
    backgroundColor: _vm.isMob ? _vm.memoryCardBackgroundColor : '#86cac6',
  })},[_c('div',{staticClass:"cancel-wrapper"},[(_vm.memory.speach && _vm.memory.speach !== 'pass')?_c('VoiceButton',{attrs:{"speachSrc":_vm.memory.speach}}):_vm._e(),_c('div',{staticClass:"cancel-cross",on:{"click":function($event){return _vm.showFullMemoryCard()}}},[_vm._v("✕")])],1),_c('div',{class:{
      'full-memory-card-wrapper': true,
      'fade-out': _vm.fadeOutFlag,
      'disabled-scroll-bar': _vm.disabledScrollBarFlag,
    },style:({
      backgroundColor: _vm.memoryCardBackgroundColor,
    })},[_c('div',{class:{
        'profile-wrapper': true,
        'fly-in-1': true,
      }},[_vm._m(0),_c('div',{staticClass:"profile-name-wrapper"},[_c('div',{staticClass:"profile-job"},[_vm._v(_vm._s(_vm.memory.job))]),_c('div',{staticClass:"profile-name"},[_vm._v(_vm._s(_vm.memory.name))])])]),_c('div',{class:{
        'text-wrapper': true,
        'fly-in-2': true,
      }},[_vm._v("\n      "+_vm._s(_vm.memory.body)+"\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-picture"},[_c('img',{attrs:{"src":"images/papercrane.svg","height":"50","width":"50"}})])}]

export { render, staticRenderFns }